module.exports = __webpack_public_path__ + "static/media/Imagen-no-disponible.74654977.png";